export default {"src":"/_next/static/media/SQL Server.8a4a4363.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};